import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: null,
};

export const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    setFeedbackStatus: (state, action) => {
      state.status = action.payload;
    },

    resetFeedback: () => initialState,
  },
});

export const {
  setFeedbackStatus,

  resetFeedback,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;
